module.exports = __webpack_public_path__ + "static/img/qrCode.a938c43a.png";